import React, { useEffect, useState } from "react";
import axios from "../api/baseurl";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Pagination } from "react-bootstrap";
import AddLabInvoicesByAdmin from "./addLabInvoicesByAdmin";
import { format, parse } from "date-fns";
import InvoiceTransactionsHistory from "./invoiceTransactionsHistory";
import { FiInfo } from "react-icons/fi";
import "./hm-theme.css";

function IncomingAdminInvoices() {
  const [invoices, setInvoices] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isInvoiceTransactionModalOpen, setIsInvoiceTransactionModalOpen] = useState(false);
  const [selectedInvoiceId, setSelectedInvoiceId] = useState(null);

  const [loader, setLoader] = useState(true);
  const [labs, setLabs] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [selectedLab, setSelectedLab] = useState("all");
  const [selectedCompany, setSelectedCompany] = useState("all");
  const [invoiceNumberFilter, setInvoiceNumberFilter] = useState(null);
  const [labTypeFilter, setLabTypeFilter] = useState("all");
  const [selectedDate, setSelectedDate] = useState(null);
  const [statusFilter, setStatusFilter] = useState("all");
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");

  const navigate = useNavigate();
  const token = JSON.parse(localStorage.getItem("data")).token;

  useEffect(() => {
    if (
      searchTerm ||
      selectedLab !== "all" ||
      selectedCompany !== "all" ||
      invoiceNumberFilter ||
      selectedDate ||
      statusFilter !== "all" ||
      labTypeFilter !== "all"
    ) {
      setCurrentPage(0);
    }
  }, [searchTerm, selectedLab, selectedCompany, invoiceNumberFilter, selectedDate, statusFilter, labTypeFilter]);

  useEffect(() => {
    if (
      searchTerm ||
      selectedLab !== "all" ||
      selectedCompany !== "all" ||
      invoiceNumberFilter ||
      selectedDate ||
      statusFilter !== "all" ||
      labTypeFilter !== "all"
    ) {
      searchData(currentPage);
    } else {
      getData(currentPage);
    }
  }, [searchTerm, selectedLab, selectedCompany, invoiceNumberFilter, selectedDate, statusFilter, labTypeFilter, currentPage]);

  const searchData = async (page = 0) => {
    setLoader(true);
    try {
      const searchUrl = `/api/invoiceSearch/searchAdminIncomingInvoices?page=${page}&size=10`;
      const requestData = {
        invoiceNumber: invoiceNumberFilter || null,
        date: selectedDate || null,
        labId: selectedLab === "all" ? null : selectedLab,
        companyId: selectedCompany === "all" ? null : selectedCompany,
        status: statusFilter === "all" ? null : statusFilter,
        labType: labTypeFilter === "all" ? null : labTypeFilter,
        invoicesFor: "Admin",
      };

      const response = await axios.post(searchUrl, requestData, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setInvoices(response.data.content || []);
      setCurrentPage(response.data.number || 0);
      setTotalPages(response.data.totalPages || 0);
      setLoader(false);
    } catch (error) {
      setLoader(false);
      handleError(error);
    }
  };

  const getData = async (pageNumber = 0) => {
    setLoader(true);
    try {
      const trans = await axios.get(`/api/invoices/getAllAdminInvoices/invoiceType=incoming`, {
        params: { page: pageNumber },
        headers: { Authorization: `Bearer ${token}` },
      });

      setInvoices(trans.data.content || []);
      setCurrentPage(trans.data.number || 0);
      setTotalPages(trans.data.totalPages || 0);

      const response = await axios.get("/api/labdetails/getLabs", {
        headers: { Authorization: `Bearer ${token}` },
      });
      setLabs(response.data || []);

      const compRes = await axios.get("/api/companydetails/getCompanies", {
        headers: { Authorization: `Bearer ${token}` },
      });
      setCompanies(compRes.data || []);

      setLoader(false);
    } catch (error) {
      setLoader(false);
      handleError(error);
    }
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  function handleError(error) {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else if (error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      } else if (error.response.data && error.response.data.code) {
        toast.error(error.response.data.code);
      } else {
        toast.error("An error occurred.");
      }
    } else if (error.message) {
      toast.error(error.message);
    } else {
      toast.error("An error occurred.");
    }
  }

  const handleLabFilterChange = (event) => {
    setSelectedLab(event.target.value);
    setSelectedCompany(null);
  };

  const handleCompanyFilterChange = (event) => {
    setSelectedCompany(event.target.value);
    setSelectedLab(null);
    setLabTypeFilter(null);
  };

  const handleSearchInvoiceNumber = (event) => {
    setInvoiceNumberFilter(event.target.value.toLowerCase());
  };

  const handleDateChange = (date) => {
    if (date) {
      const formattedDate = format(date, "MM/yyyy");
      setSelectedDate(formattedDate);
    } else {
      setSelectedDate(null);
    }
  };

  const handleStatusFilterChange = (e) => {
    setStatusFilter(e.target.value);
  };

  const handleLabTypeFilterChange = (e) => {
    setLabTypeFilter(e.target.value);
    setSelectedCompany(null);
  };

  const handleViewPdf = async (id) => {
    const token = JSON.parse(localStorage.getItem("data")).token;
    await axios({
      url: `/api/invoices/download/id=${id}`,
      method: "GET",
      responseType: "blob",
      headers: { Authorization: `Bearer ${token}` },
    }).then((response) => {
      const contentType = response.headers["content-type"];
      let extension = "";

      if (contentType.includes("application/pdf")) {
        extension = "pdf";
      } else if (contentType.includes("image/jpeg")) {
        extension = "jpg";
      } else if (contentType.includes("image/png")) {
        extension = "png";
      } else {
        console.error("Unsupported file type:", contentType);
        return;
      }

      const url = window.URL.createObjectURL(new Blob([response.data], { type: contentType }));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `file.${extension}`);
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    });
  };

  const getStatusBadge = (status) => {
    if (!status) return "hm-badge hm-badge-info";
    const s = status.toUpperCase();
    if (s.includes("PAID")) return "hm-badge hm-badge-success";
    if (s.includes("PARTIAL")) return "hm-badge hm-badge-warning";
    return "hm-badge hm-badge-info";
  };

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const maxPageNumbersToShow = 5;
    let startPage = Math.max(0, currentPage - 2);
    let endPage = Math.min(totalPages - 1, currentPage + 2);

    if (currentPage <= 2) {
      endPage = Math.min(totalPages - 1, maxPageNumbersToShow - 1);
    }

    if (currentPage >= totalPages - 3) {
      startPage = Math.max(0, totalPages - maxPageNumbersToShow);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <Pagination.Item key={i} active={i === currentPage} onClick={() => handlePageChange(i)}>
          {i + 1}
        </Pagination.Item>
      );
    }
    return pageNumbers;
  };

  const handleCreateInvoices = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    getData();
  };

  const handleOpenTransactionHistory = (invoiceId) => {
    setSelectedInvoiceId(invoiceId);
    setIsInvoiceTransactionModalOpen(true);
  };

  const handleCloseInvoiceTransactionModal = () => {
    setIsInvoiceTransactionModalOpen(false);
    setSelectedInvoiceId(null);
    searchData(0);
  };

  return (
    <div className="pt-2">
      {loader && <div className="loading"></div>}

      {/* Header Bar */}
      <div className="d-flex align-items-center justify-content-between mb-4">
        <div className="d-flex align-items-center gap-2">
          <h5 className="mb-0 fw-bold" style={{ fontSize: "1.1rem" }}>
            Incoming Invoices
          </h5>
          <span className="hm-badge hm-badge-primary">{invoices.length} Records</span>
        </div>
        <button className="btn-hm-primary" onClick={handleCreateInvoices}>
          <i className="material-icons" style={{ fontSize: "1rem" }}>
            add
          </i>
          Add Invoice
        </button>
      </div>

      {/* Filter Card */}
      <div className="hm-card mb-4" style={{ boxShadow: "none", border: "1px solid #e2e8f0" }}>
        <div className="hm-card-header">
          <h3 className="hm-card-title">
            <i className="material-icons">filter_alt</i>
            Search & Filter
          </h3>
        </div>
        <div className="hm-card-body">
          <div className="row g-3 align-items-end">
            <div className="col-md-4">
              <label htmlFor="labFilter" className="form-label small fw-semibold">
                Filter by Lab
              </label>
              <select
                id="labFilter"
                className="form-select"
                value={selectedLab || "all"}
                onChange={handleLabFilterChange}
              >
                <option value="all">All Labs</option>
                {labs.map((lab) => (
                  <option key={lab.id} value={lab.id}>
                    {lab.labname} - {lab.labcode}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-md-4">
              <label htmlFor="labTypeFilter" className="form-label small fw-semibold">
                Filter by Lab Type
              </label>
              <select
                id="labTypeFilter"
                className="form-select"
                value={labTypeFilter || "all"}
                onChange={handleLabTypeFilterChange}
              >
                <option value="all">ALL</option>
                <option value="Regulated">Regulated</option>
                <option value="Unregulated">Unregulated</option>
              </select>
            </div>

            <div className="col-md-4">
              <label htmlFor="companyFilter" className="form-label small fw-semibold">
                Filter by Company
              </label>
              <select
                id="companyFilter"
                className="form-select"
                value={selectedCompany || "all"}
                onChange={handleCompanyFilterChange}
              >
                <option value="all">All Companies</option>
                {companies.map((company) => (
                  <option key={company.id} value={company.id}>
                    {company.companyname}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-md-4">
              <label htmlFor="statusFilter" className="form-label small fw-semibold">
                Filter by Status
              </label>
              <select
                id="statusFilter"
                className="form-select"
                value={statusFilter || "all"}
                onChange={handleStatusFilterChange}
              >
                <option value="all">ALL</option>
                <option value="Invoice Generated">Invoice Generated</option>
                <option value="Partial Payment">Partial Payment</option>
                <option value="Paid">Paid</option>
              </select>
            </div>

            <div className="col-md-4">
              <label htmlFor="invoiceNumberFilter" className="form-label small fw-semibold">
                Search by Invoice Number
              </label>
              <div className="position-relative">
                <input
                  type="search"
                  className="form-control ps-4"
                  id="invoiceNumberFilter"
                  placeholder="Search Invoice No..."
                  value={invoiceNumberFilter || ""}
                  onChange={handleSearchInvoiceNumber}
                />
                <i
                  className="material-icons position-absolute text-muted"
                  style={{ left: "10px", top: "50%", transform: "translateY(-50%)", fontSize: "1.1rem" }}
                >
                  search
                </i>
              </div>
            </div>

            <div className="col-md-4">
              <label htmlFor="monthYearFilter" className="form-label small fw-semibold">
                Filter by Month & Year
              </label>
              <DatePicker
                selected={selectedDate ? parse(selectedDate, "MM/yyyy", new Date()) : null}
                onChange={handleDateChange}
                showMonthYearPicker
                dateFormat="MM/yyyy"
                className="form-select"
                placeholderText="Select Month and Year"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Table Card */}
      <div className="hm-card" style={{ boxShadow: "none", border: "1px solid #e2e8f0" }}>
        <div style={{ overflowX: "auto" }}>
          <table className="hm-table">
            <thead>
              <tr>
                <th>Lab</th>
                <th>Lab Type</th>
                <th>Lab Address</th>
                <th>Company</th>
                <th>Date</th>
                <th>Period</th>
                <th>Invoice No.</th>
                <th>Gross Amt</th>
                <th>Tax</th>
                <th>Net Pay</th>
                <th>File</th>
                <th>Status & Actions</th>
              </tr>
            </thead>
            <tbody>
              {invoices.length === 0 ? (
                <tr>
                  <td colSpan="12">
                    <div className="hm-empty-state py-4">
                      <i className="material-icons">receipt_long</i>
                      <p>{loader ? "Loading incoming invoices..." : "No incoming invoices found"}</p>
                    </div>
                  </td>
                </tr>
              ) : (
                invoices.map((invoice) => (
                  <tr key={invoice.id}>
                    <td className="fw-semibold">
                      {invoice.company ? "NA" : invoice.lab?.labname}{" "}
                      {invoice.company ? "" : `(${invoice.lab?.labcode})`}
                    </td>
                    <td>
                      {invoice.company
                        ? "NA"
                        : invoice.lab?.regulated === true
                        ? "Regulated"
                        : "Unregulated"}
                    </td>
                    <td>{invoice.company ? "NA" : invoice.lab?.addressLine1}</td>
                    <td className="fw-semibold">
                      {invoice.lab ? "NA" : invoice.company?.companyname}{" "}
                      {invoice.lab ? "" : `(${invoice.company?.companycode})`}
                    </td>
                    <td>{invoice.date}</td>
                    <td>
                      <span className="small text-muted">
                        {invoice.startdate} to {invoice.enddate}
                      </span>
                    </td>
                    <td className="fw-bold">{invoice.invoicenumber}</td>
                    <td>₹{invoice.grossamount}</td>
                    <td>{invoice.tax}%</td>
                    <td className="fw-bold text-success">₹{invoice.netpay}</td>
                    <td>
                      {invoice.invoiceFileUploaded === true ? (
                        <button
                          className="btn btn-outline-primary btn-sm rounded-pill py-0 px-2 d-flex align-items-center gap-1"
                          onClick={() => handleViewPdf(invoice.id)}
                          style={{ fontSize: "0.75rem" }}
                        >
                          <i className="material-icons" style={{ fontSize: "0.85rem" }}>
                            visibility
                          </i>
                          View
                        </button>
                      ) : (
                        <span className="text-muted small">No File</span>
                      )}
                    </td>
                    <td>
                      <div className="d-flex align-items-center gap-1">
                        <span className={getStatusBadge(invoice.invoiceStatus?.status)}>
                          {invoice.invoiceStatus?.status}
                        </span>
                        {invoice.invoiceStatus?.status === "Paid" && (
                          <FiInfo
                            onClick={() => handleOpenTransactionHistory(invoice.id)}
                            style={{ cursor: "pointer", color: "#2cb6e9" }}
                            title="Transaction History"
                          />
                        )}
                      </div>
                      {invoice.invoiceStatus?.status === "Partial Payment" && (
                        <div className="mt-1 small">
                          <span className="text-success fw-semibold">Paid: ₹{invoice.paidAmount}</span>
                          <span className="text-danger fw-semibold ms-2">Pending: ₹{invoice.pendingAmount}</span>
                        </div>
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {totalPages > 1 && (
          <div className="d-flex justify-content-center py-3 border-top">
            <Pagination className="hm-pagination">
              <Pagination.First onClick={() => handlePageChange(0)} disabled={currentPage === 0} />
              <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 0} />
              {renderPageNumbers()}
              <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage >= totalPages - 1} />
              <Pagination.Last onClick={() => handlePageChange(totalPages - 1)} disabled={currentPage >= totalPages - 1} />
            </Pagination>
          </div>
        )}
      </div>

      {isModalOpen && (
        <AddLabInvoicesByAdmin isOpen={isModalOpen} onRequestClose={handleCloseModal} />
      )}

      {isInvoiceTransactionModalOpen && (
        <InvoiceTransactionsHistory
          isOpen={isInvoiceTransactionModalOpen}
          onRequestClose={handleCloseInvoiceTransactionModal}
          invoiceId={selectedInvoiceId}
        />
      )}
    </div>
  );
}

export default IncomingAdminInvoices;


